import React, { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core';
import { Button, CircularProgress, Grid, Tooltip, useMediaQuery } from '@mui/material'
import { guardarDatosMatriculas } from 'app/features/Matriculas/matriculasApi';
import { nuevoAdjunto } from 'utils/adjuntosLogic';
import { Domicilios } from './Domicilios'
import { DomiciliosCancelacion } from '../cancelacion/DomiciliosCancelacion'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import Swal from 'sweetalert2';

export const TabDomicilios = ({ datos, libraries, bloquearBtn, setDatos, setValue, ObrasSociales, loaderBtnGuardar, setLoaderBtnGuardar, setBloquearBtn, idEstado, setMatriculas, setCantidadTramites, tpoUser, location, setLocation, datosModificados, datosDomicilioModificados, datosFamiliarModificados }) => {

    const [errorCuit, setErrorCuit] = useState({ display: "none" });
    const editarFotoSlice = useSelector(state => state.editarDatosProfesionalReducer);
    const [tipoCalleSelect, setTipoCalleSelect] = useState([]);
    const [openModalDomicilio, setOpenModalDomicilio] = useState(false);
    const tipoUsuario = Number(localStorage.userType);
    const [confirmaDomicilios, setConfirmaDomicilios] = useState(false);
    const tpoTramite = Number(localStorage.tpoTramite);

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const datosDomicilioModificadosFiltrados = tpoTramite === 3 ? datosDomicilioModificados.filter(prop => prop === 'celular') : datosDomicilioModificados

    const onSubmit = data => {
        let erroresMostrar = "";
        let mostrarErrorDomicilio = 0;
        let documento = datos.NroDocumento;
        let contadorConfirmados = 0;
        // let contadorDomiciliosCorrectos = 0; 
        documento = documento.replace(/\./g, '').replace(/[a-z ]/g, "");
        let cuit = datos.CuitCuil;
        cuit = cuit.substring(3);
        cuit = cuit.substring(0, 8);
        const tiposValidos = ["Particular", "Profesional", "Constituido", "Correspondencia", "Real Caja"];

        if (datos.domicilios.length < 5) {
            Swal.fire({
                title: 'Atención', html: 'No posee todos los domicilios cargados <br> Por favor realice un trámite de modificacion de datos para poder seguir con el tramite de cancelación.',
                icon: 'warning', showCloseButton: true, showCancelButton: false,
                confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            });
            return false;
        }

        datos.domicilios.forEach((domicilio) => {
            // if(tiposValidos.includes(domicilio.tipoDomicilio.trim())){
            //     contadorDomiciliosCorrectos++;
            // }

            if (domicilio.confirmaDomicilio === true) {
                contadorConfirmados++;
            }
        });


        // if(contadorDomiciliosCorrectos < 5){
        //     Swal.fire({
        //         title: 'Atención', html: 'No posee todos los domicilios cargados brbrbrbrbrrbb', 
        //         icon: 'warning', showCloseButton: true, showCancelButton: false, 
        //         confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
        //     });
        //     return false;
        // }

        if (contadorConfirmados < 5) {
            Swal.fire({
                title: 'Atención', html: 'Le falta confirmar 1 o más domicilios',
                icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            })
            return false;
        }

        if (cuit.startsWith("0")) {
            cuit = cuit.substring(1);
        }

        // if (datos.CuitCuil.length !== 13 || cuit !== documento) {
        //     Swal.fire({
        //         title: 'Atención', html: 'El CUIT-CUIL ingresado no es valido',
        //         icon: 'warning',showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
        //     })
        //     return false;
        // }

        if (tpoTramite !== 3 && !editarFotoSlice.fotoActual && !editarFotoSlice.fotoNueva) {
            Swal.fire({ title: 'Atención', html: 'Debe cargar una foto actual', icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true });
            return false;
        }

        // if(datos.ObraSocial === '' || datos.ObraSocial === 'Sin Datos'){
        //     Swal.fire({ title: 'Atención', html: 'Debe seleccionar una obra social', icon: 'warning',showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true});
        //     return false;
        // }

        datos.domicilios.map((domicilio, index) => {
            const errores = [];

            if (domicilio.calle === "") errores.push("calle");
            if (domicilio.celular === "" && tpoTramite !== 3) errores.push("celular");
            if (domicilio.caracteristica === null && tpoTramite !== 3) errores.push("característica");
            if (domicilio.caracteristica && domicilio.caracteristica.length > 5 && tpoTramite !== 3) errores.push("característica (longitud mayor a 5)");
            if (domicilio.caracteristicaFijo && domicilio.caracteristicaFijo.length > 5) errores.push("característica fija (longitud mayor a 5)");
            if (isNaN(domicilio.caracteristica) && tpoTramite !== 3) errores.push("característica (no es un número)");
            if (isNaN(domicilio.celular) && tpoTramite !== 3) errores.push("celular (no es un número)");

            if (errores.length > 0 && mostrarErrorDomicilio === 0) {
                if (erroresMostrar !== "") erroresMostrar += ", ";
                erroresMostrar += `<b>Domicilios</b>: ${errores.join(", ")}`;
                mostrarErrorDomicilio = 1;
            }

        })

        if (erroresMostrar !== "") {
            Swal.fire({
                title: 'Atención', html: 'Debe completar correctamente los siguientes datos:' + erroresMostrar,
                icon: 'warning', showCloseButton: true, showCancelButton: false,
                confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            });
            return false;
        }

        if (editarFotoSlice.deseaCambiarFoto) {
            let adjuntoDeFoto = datos.adjuntos.find(a => a.fileType === "FotoPerfil");
            if (adjuntoDeFoto) {
                adjuntoDeFoto.file = editarFotoSlice.fotoNueva;
            } else {
                adjuntoDeFoto = nuevoAdjunto("FotoPerfil", "image/jpeg", editarFotoSlice.fotoNueva);
                datos.adjuntos.push(adjuntoDeFoto);
            }
            let adjuntoDeFotoFull = datos.adjuntos.find(a => a.fileType === "FotoPerfilFull");
            if (adjuntoDeFotoFull) {
                adjuntoDeFotoFull.file = editarFotoSlice.fotoNuevaFullSize;
            } else {
                adjuntoDeFotoFull = nuevoAdjunto("FotoPerfilFull", "image/jpeg", editarFotoSlice.fotoNuevaFullSize);
                datos.adjuntos.push(adjuntoDeFotoFull);
            }


        }

        // getProfesionalValidarCuit(datos.CuitCuil.replace(/-/gi, '')).then((value) => {
        // if (!value.data.response) {
        //     setErrorCuit({ display: '' })
        //     return false;
        // } else {
        
        const merged = {...datos};
            
        if(localStorage.tpoTramite === "3" && idEstado === 6){
            delete merged.fechaCancelacion;
        } 


        setLoaderBtnGuardar(true)
        setBloquearBtn(true);
        guardarDatosMatriculas({ datos: JSON.stringify(merged), estado: idEstado, tpo_tramite: Number(localStorage.tpoTramite) }).then(async (value) => {
            setMatriculas(value.data);
            setLoaderBtnGuardar(false);
            setBloquearBtn(false);
            if (value.data.resultado) {
                setValue("4");
            } else {
                Swal.fire({
                    title: 'Atención', html: value.data.mensaje !== '' && value.data.mensaje !== null ? value.data.mensaje : 'Ocurrio un error al guardar los datos. Por favor vuelva a intentarlo',
                    icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
                })
                return false;
            }
        });
        // }
        // });
    }

    // const handleChangeTab = () => {
    //     setValue("4");
    //   }; 

    useEffect(() => {
        if (tipoUsuario === 0 && idEstado !== 2 && idEstado !== 7) {
            const iconHtml = renderToString(<ArrowDownwardRoundedIcon style={{ fontSize: '24px', verticalAlign: 'middle' }} />);
            Swal.fire({
                title: 'Atención',
                html: `
                    <div style="text-align: center;">
                        Debe confirmar/ actualizar cada uno de los siguientes domicilios con carácter de Declaración Jurada:<br><br>
                        <div style="display: inline-block; text-align: left; padding-left: 45px; line-height: 1.8;">
                            <b>Particular</b>.<br>
                            <b>Profesional</b>.<br>
                            <b>Constituido</b>.<br>
                            <b>Correspondencia</b>.<br>
                            <b>Real Caja</b>.
                        </div>
                    </div>
                `,
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: true
            });
        }
    }, []);

    return (
        <Grid>
            {
                datosDomicilioModificadosFiltrados.length > 0 &&
                <Tooltip
                    title={`Se han modificado los siguientes domicilios: ${datosDomicilioModificadosFiltrados[0].changedProperties.join(", ")}`}
                    placement="right"
                >
                    <WarningAmberOutlinedIcon sx={{ color: 'red !important', ml: 1 }} />
                </Tooltip>
            }
            {
                tpoTramite !== 3 ? (
                    <Domicilios datos={datos} libraries={libraries} setDatos={setDatos} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} location={location} setLocation={setLocation} ValorTab={setValue} idEstado={idEstado} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} editarDatos={1} setMatriculas={setMatriculas} />
                )
                :
                (
                    <DomiciliosCancelacion datos={datos} libraries={libraries} setDatos={setDatos} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} location={location} setLocation={setLocation} ValorTab={setValue} idEstado={idEstado} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} editarDatos={1} setMatriculas={setMatriculas} />
                )
            }
            <Grid container>
                <Grid item md={6} xs={6} sx={{ mt: 3 }} >
                    <Button startIcon={<ArrowBackIosIcon />} onClick={() => setValue("2")} variant="contained" type="submit" color="error" disabled={bloquearBtn} >
                        Atras
                    </Button>
                </Grid>
                <Grid item md={6} xs={6}>
                    <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
                        <Button disabled={bloquearBtn} endIcon={<ArrowForwardIosIcon />} onClick={onSubmit} variant="contained" color="secondary">
                            {loaderBtnGuardar ? (isXs ? (<CircularProgress size={25} />) : (<><CircularProgress size={25} /> Continuar </>)) : ('Continuar')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
